/**
 * Cấu hình dayjs tập trung cho toàn ứng dụng.
 * Import module này (trực tiếp hoặc qua src/index.js) trước khi format/xử lý ngày.
 *
 * Quy ước tuần (Thời khóa biểu, lịch tháng):
 * - Luôn dùng startOf("isoWeek") / endOf("isoWeek") cho đầu/cuối tuần Thứ 2.
 * - Không dùng startOf("week").add(1, "day") — phụ thuộc locale (vi weekStart=1, en=0).
 */
import dayjs from "dayjs";
import "dayjs/locale/vi";
import relativeTime from "dayjs/plugin/relativeTime";
import isoWeek from "dayjs/plugin/isoWeek";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(relativeTime);
dayjs.extend(isoWeek);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.locale("vi");
dayjs.tz.setDefault("Asia/Ho_Chi_Minh");

export default dayjs;
